export const T = {
  en_GB: {
    productColumn: "Product",
    totalRow: "Total",
    noProducts: "No products in this collection. Add products in the Products tab first.",
    noRiskScores: "Risk model has no scores configured.",
    error: "Error",
    failedToSave: "Failed to save weight",
    weightOutOfRange: "Weight must be between 0 and 100",
    riskScore: "Risk score",
  },
  nb_NO: {
    productColumn: "Produkt",
    totalRow: "Totalt",
    noProducts: "Ingen produkter i denne samlingen. Legg til produkter i Produkter-fanen først.",
    noRiskScores: "Risikomodellen har ingen score konfigurert.",
    error: "Feil",
    failedToSave: "Kunne ikke lagre vekt",
    weightOutOfRange: "Vekt må være mellom 0 og 100",
    riskScore: "Risikoscore",
  },
} as const;
